/**
 * Created by abdulhafeth on 4/24/16.
 */
angular
    .module('harriApp').filter('showPositions', ["$filter", function ($filter) {
        return function (positions) {
            if (!$.isArray(positions)) {
                return positions;
            }
            var result = "";
            for (var index  in positions) {
                var position = positions[index];
                if (result !== "") {
                    result += ", ";
                }
                result += position.name ? position.name : position;
            }
            return result;
        }
    }]);

angular
    .module('harriApp').filter('showCategories', ["$filter", function ($filter) {
        return function (positions) {
            if (!$.isArray(positions)) {
                return positions;
            }
            var result = "";
            for (var index  in positions) {
                var position = positions[index];
	            if (result.indexOf(position.category.name) < 0) {
		            if (result !== "") {
			            result += ", ";
		            }
		            result += position.category.name;
	            }
            }
            return result;
        }
    }]);


angular
    .module('harriApp').filter('showThreeWords', ["$filter", function ($filter) {
        return function (profile) {
            if (!profile) {
                return profile;
            }
            var threeWords = [profile.word1, profile.word2, profile.word3];
            var result = "";
            for (var index  in threeWords) {
                var word = threeWords[index];
                if (word) {
                    if (result !== "") {
                        result += ", ";
                    }
                    result += word;
                }
            }
            return result;
        }
    }]);

angular
    .module('harriApp')
    .filter('tsShiftDate', ["$filter", function ($filter) {
        return function (dates) {

            if (!dates || dates.length === 0) {
                return;
            }

            var startDate = moment(dates[0]);
            var endDate = moment(dates[1]);

            if (!startDate.isSame(endDate, 'day')) {
                return startDate.format('dddd MMMM Do, hh:mm A') + ' - ' + endDate.format('dddd MMMM Do, hh:mm A');
            }

            return startDate.format('dddd MMMM Do') + ' (' + startDate.format('hh:mm A') + " - " + endDate.format('hh:mm A') + ")";
        }

    }]);


angular
    .module('harriApp')
    .filter('tsTimeOffDate', ["$filter", function ($filter) {
        return function (request) {

            if (!request || !request.start_date) {
                return;
            }

            var startDate = moment(request.start_date);
            request.end_date = request.end_date || request.start_date;
            var endDate = moment(request.end_date);
            var startTimeString = $filter('formatHours')(request.days[0].from_time);
            var endTimeString = $filter('formatHours')(request.days[0].to_time);

            var startTime = moment("Jan 1, 1970 " + startTimeString);
            var endTime = moment("Jan 1, 1970 " + endTimeString);

            if (!startDate.isSame(endDate, 'day')) {
                return ' from ' + startDate.format('dddd MMMM Do') + ' to ' + endDate.format('dddd MMMM Do');
            }

            if (request.days[0].is_all_day) {
                return ' on ' + startDate.format('dddd MMMM Do');
            }

            return ' on ' + startDate.format('dddd MMMM Do') + ' from ' + startTime.format('hh:mm A') + ' to '
                + endTime.format("hh:mm: A");
        }
    }]);

angular
    .module('harriApp').filter('shiftResources', ["$filter", function ($filter) {
        return function (resources) {
            if (!$.isArray(resources)) {
                return resources;
            }
            var result = "";
            for (var index  in resources) {
                var resource = resources[index];
                if (result !== "") {
                    result += ", ";
                }
                result += resource.quantity + " " + resource.position.name;
            }
            return result;
        }
    }]);
